import { useState } from 'react';
import { Button } from '../Button';
import { Typography } from '../Typography';
import styles from './ProductFAQ.module.scss';
import { MdAdd, MdRemove } from 'react-icons/md';

interface FaqItem {
  _id: string;
  question: string;
  answer: string;
  category: string;
}

const ProductFAQ = ({ categories, faqs }: { categories: string[]; faqs: FaqItem[] }) => {
  const [expandedQuestionIndex, setExpandedQuestionIndex] = useState<number | null>(null);

  const filteredFaqs = faqs.filter((faq) => faq.category === 'Video Plugin Development Framework');

  const toggleAnswer = (index: number) => {
    setExpandedQuestionIndex(expandedQuestionIndex === index ? null : index);
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.contentContainer}>
        <div className={styles.faqPage}>
          <div className={styles.contentSection}>
            <main>
              <section className={styles.faqSection}>
                <div className={styles.faqSectionTitle}>
                  <Typography variant="display-md" as="h2" color="primary">
                    Frequently asked questions
                  </Typography>

                  <Typography variant="text-xl" color="grayDark-400">
                    Everything you need to know about the product and billing.
                  </Typography>
                </div>

                {/* FAQ Items */}
                <div className={styles.faqItems}>
                  {filteredFaqs.map((faq, index) => (
                    <div key={faq._id} className={styles.faqItem}>
                      <div className={styles.faqQuestion} onClick={() => toggleAnswer(index)}>
                        <Typography variant="text-md" color="primary">
                          {faq.question}
                        </Typography>
                        <div className={styles.expandIcon}>
                          {expandedQuestionIndex === index ? (
                            <MdRemove size={20} />
                          ) : (
                            <MdAdd size={20} />
                          )}
                        </div>
                      </div>
                      {expandedQuestionIndex === index && (
                        <div className={styles.faqAnswer}>
                          <Typography variant="text-sm" color="grayDark-400">
                            {faq.answer}
                          </Typography>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </section>
            </main>

            {/* Still Have Questions Section */}
            <section className={styles.stillHaveQuestionsSection}>
              <div className={styles.stillHaveQuestionsContent}>
                <div className={styles.teamImages}>
                  <img
                    src="/get-in-touch.svg"
                    alt="Contact EPEN Ltd. Support Team for Video Plugin Development Questions"
                  />
                </div>

                <div className={styles.stillHaveQuestionsText}>
                  <Typography variant="text-xl" color="primary">
                    Still have questions?
                  </Typography>

                  <Typography variant="text-lg" color="grayDark-400">
                    Can&apos;t find the answer you&apos;re looking for? Please chat to our friendly
                    team.
                  </Typography>
                </div>

                <Button
                  onClick={() => {
                    window.location.href = '/contact-us';
                  }}
                >
                  Get in touch
                </Button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFAQ;
